import { React, useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';
import { ReactComponent as CheckIconSvg } from '../../image/Check3.svg';
import { ReactComponent as InfiniteIconSvg } from '../../image/Infinite.svg';

const IndexMemberShipMaxCountInput = forwardRef((props, ref) => {
  const { dateVal, setDateVal, explanation, isRegularPayment, unit, index } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

	const [changed, setChanged] = useState(false);
  const [noLimit, setNoLimit] = useState(false);

  const InputRef = useRef();

  useImperativeHandle(ref, () => ({
		setValue: (val) => {
      if (val === -1) {
        setDateVal(0, index);
        setNoLimit(true);
      }
      else{
        setDateVal(val, index);
        setNoLimit(false);
      }
		},
		getValue: () => {
      if (noLimit) return -1;
      else return dateVal;
		},
    reset: (noLimit) => {
      setDateVal(0, index);
      setNoLimit(noLimit);
    }
	}))

  // 회원권 전환으로 값이 교체돼도 무제한 표시가 값과 어긋나지 않도록 동기화 //
  useEffect(() => {
    if (dateVal === -1) setNoLimit(true);
    else setNoLimit(false);
  }, [dateVal])

	function handleChange(e) {
    var regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 매칭하는 정규식
    var result = e.target.value.replace(regex, "");	// 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경
   
    if (e.target.value === '') setDateVal(0, index);
		else setDateVal(parseInt(result), index);
		setChanged(true);
	}

	function handleFocus(e) {

	}

  function upButtonClick() {
    if (noLimit) return;
    setDateVal(dateVal + 1, index);
  }

  function downButtonClick(){
    if (noLimit) return;
    if (dateVal > 0) setDateVal(dateVal - 1, index);
  }

  // 무제한 토글은 부모 옵션 값(-1 = 무제한)까지 바꿔야 저장 요청에 실린다 //
  function onClickNoLimit() {
    if (!noLimit) setDateVal(-1, index);
    else setDateVal(0, index);

    setNoLimit(!noLimit);
  }
  return (
    <TopLevelWrapper>
      <ExplanationWrapper>
        <Explanation>{explanation}</Explanation>
        {
          !isRegularPayment &&
          <LimitWrapper>
            <InfiniteIcon />
            <LimitCheckBox noLimit={noLimit} onClick={onClickNoLimit}>
              {noLimit && <CheckIcon />}
            </LimitCheckBox>
          </LimitWrapper>
        }
      </ExplanationWrapper>
      <InputWrapper>
        <Input 
          disabled={noLimit}
          ref={InputRef}
          placeholder={0}
          value={noLimit ? t('system.noLimit') : dateVal}
          onChange={handleChange}
          onFocus={handleFocus}/>
        {/* <ButtonWrapper>
          <Button onClick={upButtonClick}><StyledArrow isUp={true} /></Button>
          <Button onClick={downButtonClick}><StyledArrow isUp={false} /></Button>
        </ButtonWrapper> */}
        <Text>{unit}</Text>
      </InputWrapper>
    </TopLevelWrapper>
  )
})

export default IndexMemberShipMaxCountInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  
  transition: all 0.3s ease-in-out;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: default;
    }
  }
`;

const LimitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const LimitCheckBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 20px;
  height: 20px;

  border: 1px solid ${props => props.noLimit ? props.theme.primary : props.theme.line};
  border-radius: 3px;

  margin-right: 2px;

  background-color: ${props => props.noLimit ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckIcon = styled(CheckIconSvg)`
  width: 10px;
  height: auto;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const LimitText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  margin-top: 10px;

  width: 100%;

  gap: 5px;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  // width: calc(46.31% - 18px);
  width: 100%;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;

  padding: 0 8px 0 8px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

  &:disabled {
    text-align: center;
    color: ${props => props.theme.text};
    background-color: ${props => props.theme.subBackground};
  }

  transition: all 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 2px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 8px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 9.6px;
  height: 17.7px;

  transform: ${props => props.isUp ? 'rotate(90deg)' : 'rotate(-90deg)'};

  & path {
    fill: ${props => props.theme.subText};
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 auto;
`;

const InfiniteIcon = styled(InfiniteIconSvg)`
  width: 17px;
  height: 8px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.subText};
    transition: fill 0.3s ease-in-out;
  }
`;
